import { useParams } from 'react-router-dom';
import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout';
import { useBranch, useUpdateBranch } from 'api/branchApi';
import { BranchForm } from './components';
import { useIntl } from 'react-intl';
import { Loading } from 'components/loading';

export default function ViewBranch() {
  const intl = useIntl();
  const { id } = useParams();
  const { data, isLoading, isFetching } = useBranch({
    id,
  });
  const updateMutation = useUpdateBranch(id);

  const handleSubmit = (values) => {
    updateMutation.mutate(values, {
      onSuccess() {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.updateSuccess`,
          }),
        );
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (!data) {
    return null;
  }

  return (
    <ContentWrapper title="Chỉnh sửa">
      <BranchForm
        onSubmit={handleSubmit}
        isLoading={updateMutation.isLoading}
        initialValues={data}
      />
    </ContentWrapper>
  );
}
